<template>
    <div class="">
        <div class="content content-block">
        <h4 class="title">
          Company Information
          <small>
            <a v-if="isCompanyAdmin" @click.prevent="toggleCompanyModal" href="#">(edit)</a>
          </small>
        </h4>
          <dl class="floated-list">
            <dt>name</dt>
            <dd>{{ currentCompanyInfo.companyName }}</dd>

            <dt>industry</dt>
            <dd>{{ currentCompanyInfo.companyIndustry }}</dd>

            <dt>phone</dt>
            <dd>{{ currentCompanyInfo.companyPhones[0] ? formatPhoneNumber(currentCompanyInfo.companyPhones[0].companyPhoneDigits) : '' }}</dd>

            <dt>address</dt>
            <dd>
              {{ currentCompanyInfo.companyAddresses[0].companyAddressStreet1 }}
              {{ currentCompanyInfo.companyAddresses[0].companyAddressStreet2 }}
              <br/>
              {{ currentCompanyInfo.companyAddresses[0].companyAddressCity }},
              {{ currentCompanyInfo.companyAddresses[0].companyAddressState }}
              {{ currentCompanyInfo.companyAddresses[0].companyAddressZip }}
            </dd>

            <dt>Tax ID (EIN)</dt>
            <dd>{{ currentCompanyInfo.companyTaxId }}</dd>

            <dt>DUNS</dt>
            <dd>{{ currentCompanyInfo.companyDunAndBradStreetNumber }}</dd>
          </dl>
          <div class="is-clearfix"></div>
        </div>
      <company-info-modal v-model="currentCompanyInfo" :show.sync="showCompanyModal"></company-info-modal>
    </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'
import CompanyInfoModal from '@/components/FormCompanyInfo-Modal'
import { formatPhoneNumber, digitsFromString } from '@/helpers/phoneNumberFormatter'

export default {
  name: 'CompanyInfo',

  data() {
    return {
      showCompanyModal: false
    }
  },

  mounted() {
    this.getDetails()
  },

  computed: {
    ...mapGetters('user', ['accountInfo', 'isCompanyAdmin']),
    ...mapState('company', ['currentCompanyInfo'])
  },

  methods: {
    ...mapActions('company', ['getDetails']),

    formatPhoneNumber: formatPhoneNumber,
    digitsFromString: digitsFromString,

    toggleCompanyModal() {
      this.showCompanyModal = !this.showCompanyModal
    }
  },

  components: {
    CompanyInfoModal
  }
}
</script>

<style scoped lang="scss">
.title {
  margin-bottom: 15px;

  small {
    font-weight: lighter;
    font-size: 0.7em;
  }
}

dl {
  margin-left: 15px;
}
dt {
  text-transform: capitalize;
}

dt,
dd {
  margin-top: 12px;
}
</style>
